import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

class ProductInventory extends Component {
  /**
   * CASE.SHE: the element the listener was added to. `disconnectedCallback` runs after the
   * element is detached, when `closest()` finds nothing, so the listener used to stay behind.
   * The quick-add modal replaces its product form on every opening (morph keys by `id`, and a
   * form's `id` property returns its `input[name="id"]`), so stale copies piled up on the
   * dialog, and the first of them moved the pre-order inputs out of the response before this
   * element could morph them in.
   * @type {Element | null}
   */
  #listenerTarget = null;

  connectedCallback() {
    super.connectedCallback();
    this.#listenerTarget = this.closest('.shopify-section, dialog');
    this.#listenerTarget?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#listenerTarget?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#listenerTarget = null;
  }

  /**
   * Handles product select event by updating the inventory.
   * @param {ProductSelectEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const newInventory = html.querySelector('product-inventory');
        if (!newInventory) return;

        morph(this, newInventory, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-inventory] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}
